export const NAVIGATION_LABEL = {
  NEW_SALE: 'New sale',
}

export const MENU_ID = 'positioned-menu'
